import z from "zod";
//
// Entity
//
export const DTOIPWhitelistEntry = z.object({
    isEnabled: z.boolean(),
    name: z.string(),
    range: z.string().cidr(),
});
export const DTOIPWhitelist = z.object({
    isEnabledForCloud: z.boolean(),
    isEnabledForDocs: z.boolean(),
    entries: DTOIPWhitelistEntry.array(),
});
//
// Payloads
//
export const DTOIPWhitelistUpdate = DTOIPWhitelist.partial();
export const DTOIPWhitelistResponse = z.object({
    ipWhitelist: DTOIPWhitelist,
});
